import type React from 'react';
import { Skeleton, Table } from '@heroui/react';
import { cn } from '@/utils/cnUtils';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import {
    isNumericColumn,
    type ImportHistoryColumnId,
} from './importHistoryColumns';

type ImportHistorySkeletonRowProps = {
    /** Which placeholder row this is, for its key and test ID. */
    index: number;
    columns: readonly ImportHistoryColumnId[];
};

/** A placeholder row while the history loads: one bar per column, sized like its values. */
export const ImportHistorySkeletonRow: React.FC<
    ImportHistorySkeletonRowProps
> = ({ index, columns }) => (
    <Table.Row id={`branch-import-history-skeleton-${index}`}>
        {columns.map((column) => (
            <Table.Cell key={column}>
                <Skeleton
                    className={cn(
                        'h-4 rounded-md',
                        column === 'file' ? 'w-32' : 'w-16',
                        isNumericColumn(column) && 'ms-auto',
                    )}
                    {...getNodeTestIdProp(
                        `branch-import-history-skeleton-${index}-${column}`,
                    )}
                />
            </Table.Cell>
        ))}
    </Table.Row>
);
